// External Dependencies
import React, { Component } from 'react';
import toast from 'react-hot-toast';

// UI Components
import { Modal } from '../../../UiKit';
import { CommentsPop } from '../../popups';

// Styles
import './Comments.scss';
import Button from '../../ComponentsV1/Button';
import { MessageCircle } from 'lucide-react';
import { getIDParamValueFromSmartplugURL } from '../../../utils/UtilFunctionsV1';
import {
  DASHBOARD_MODE,
  SMARTPLUG_URL_PARAMS,
} from '../../../utils/UtilConstants';
import { popUpClosedEvent, popUpOpenendEvent } from '../../../analytics/events';
import {
  EventType,
  FeatureName,
  MetricsForJumboEvent,
} from '../../../analytics/constants';

const dashboardMode = window.dashboard.mode;
export default class CommentsV1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCommemntsPopup: false,
      textAreaVal: '',
      isActive: false,
    };
  }

  componentDidMount() {
    this.getCommentsData();
  }

  getTextareaVal(event) {
    if (event.target.value && event.target.value.length) {
      this.setState({
        textAreaVal: event.target.value,
        isActive: true,
      });
    } else {
      this.setState({
        textAreaVal: event.target.value,
        isActive: false,
      });
    }
  }

  getCommentsData = () => {
    const { getCommentsData, cartId } = this.props;
    const querryParams = {};
    querryParams['cart_id'] = cartId;
    getCommentsData(querryParams);
  };

  showCommemntsPopup = () => {
    const { orderId, cartId } = this.props;
    popUpOpenendEvent({
      event_type: EventType.CLICK,
      feature_name: FeatureName.COMMENTS,
      [MetricsForJumboEvent.order_id]: orderId,
      [MetricsForJumboEvent.cart_id]: cartId,
      isNewUI: 'true',
    });
    this.setState({
      showCommemntsPopup: true,
    });
  };

  closePopup = () => {
    const { orderId, cartId } = this.props;
    popUpClosedEvent({
      event_type: EventType.CLICK,
      feature_name: FeatureName.COMMENTS,
      [MetricsForJumboEvent.order_id]: orderId,
      [MetricsForJumboEvent.cart_id]: cartId,
    });
    this.setState({
      showCommemntsPopup: false,
    });
  };

  addComments = () => {
    const { textAreaVal } = this.state;
    const { orderId, addComments } = this.props;

    const data = {
      order_id: orderId,
      comment: textAreaVal,
    };

    if (!textAreaVal?.length) return;

    if (dashboardMode === DASHBOARD_MODE.SMARTPLUG) {
      data.session_id = getIDParamValueFromSmartplugURL(
        SMARTPLUG_URL_PARAMS.UC_SESSION_ID,
      );
    }

    addComments(data)
      .then((res) => {
        if (!res || (res && res.isError === true)) {
          toast.error(res.message || 'Oooopss! something went wrong!');
          return;
        }
        toast.success('Comment successfully added!');
        this.getCommentsData();
        this.setState({
          textAreaVal: '',
          isActive: false,
        });
      })
      .catch(() => {
        toast.error('Oooopss! something went wrong!');
      });
  };

  render() {
    const dashboardMode = window.dashboard?.mode;
    let isSmartplug = dashboardMode === 'smartplug' ? true : false;
    const { comments, showOnlyBtn = false } = this.props;
    const { showCommemntsPopup, isActive } = this.state;
    const commentsCount = comments ? comments.length : '0';

    if (showOnlyBtn) {
      return (
        <>
          <button
            className='tw-text-base-green tw-text-[1.4rem] tw-font-medium tw-w-fit tw-p-0 tw-m-0 tw-leading-none tw-cursor-pointer tw-whitespace-nowrap tw-border-none tw-bg-white tw-h-full'
            onClick={this.showCommemntsPopup.bind(this)}
          >
            Comments ({commentsCount})
          </button>

          {/* See All comments Modal */}
          {showCommemntsPopup && (
            <Modal
              padding={0}
              paddingTop={'1rem'}
              type='large'
              height='100%'
              maxHeight='80vh'
              isVisible={showCommemntsPopup}
              title='Comments'
              handleClose={this.closePopup.bind(this)}
              component={<CommentsPop comments={comments} />}
            />
          )}
        </>
      );
    }

    return (
      <div
        className={`commentsContainer !tw-border-l-0 !tw-border-r-0 !tw-border-b-0 !tw-rounded-none !tw-rounded-bl-[0.8rem] ${
          isSmartplug
            ? '!tw-rounded-[0.8rem] tw-border-solid tw-border-[0.5px] tw-border-[#e9e7e7]'
            : ''
        }`}
      >
        <div className='tw-px-[1.4rem] tw-py-[1rem] tw-flex tw-items-center tw-gap-3 tw-w-full'>
          {/* header */}
          <h2 className='tw-text-[1.5rem] tw-font-medium tw-flex tw-items-center tw-gap-1 tw-text-zinc-600 tw-mr-2'>
            <MessageCircle size={18} />
            Comments
          </h2>

          {/* Comment Input field */}
          <div className='textarea tw-w-full'>
            <input
              className='tw-border-none tw-outline tw-outline-solid tw-outline-[1px] tw-outline-grey-200/50 tw-p-3 focus:tw-outline-base-green focus:tw-bg-white focus:tw-outline tw-rounded-[8px] hover:tw-bg-grey-200/20 hover:tw-transition-all hover:tw-ease-in-out focus:tw-transition-none focus:tw-ease-linear'
              value={this.state.textAreaVal}
              onChange={this.getTextareaVal.bind(this)}
              placeholder='Add a comment...'
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  this.addComments();
                }
              }}
            />
          </div>

          {/* Add comment */}
          <Button
            disabled={!isActive}
            title='Add'
            onClick={this.addComments}
            type='secondary'
          />

          {/* See all */}
          <Button
            type='outline'
            title={`See All (${commentsCount})`}
            onClick={this.showCommemntsPopup.bind(this)}
            size='small'
          />
        </div>

        {/* See All comments Modal */}
        {showCommemntsPopup && (
          <Modal
            padding={0}
            paddingTop={'1rem'}
            type='large'
            height='100%'
            maxHeight='80vh'
            isVisible={showCommemntsPopup}
            title='Comments'
            handleClose={this.closePopup.bind(this)}
            component={<CommentsPop comments={comments} />}
          />
        )}
      </div>
    );
  }
}
